import {Navigate} from 'react-router-dom';
import AdminDashboard from '../pages/admin/AdminDashboard';
import DashboardV2 from '../pages/dashboard/DashboardV2';
import SecuredRoute from '../modules/auth/authorization/SecuredRoute';
import ServiceList from '../../Domains/Service/Pages/ServiceList';
import Documents from '../pages/documents/Documents';
import OrderTracking from '../pages/order-tracking/OrderTracking';
import OrderDetails from '../pages/order-tracking/order-details/OrderDetails';
import ConfigurationList from '../pages/configuration-list/ConfigurationList';
import Marketplace from '../pages/marketplace/Marketplace';
// import Contact from '../pages/contact/Contact';
import Contact from '../../Domains/Ticket/Pages/Contact';
import NavigateToFirstAllowedRoute from '../common/components/navigation/NavigateTab';
import BuManagerV2 from '../pages/user-manager/v2/BuManagerV2';
import TicketDetailIndex from '../pages/administrative/TicketDetailIndex';
import TicketPage from "../../Domains/Ticket/Pages/TicketPage";
import SupportListPage from "../../Domains/Ticket/Pages/SupportListPage";
import WebFtpConsommation from "../../Domains/Service/Components/Hebergement/WebFtpConsommation";
import ConnexionPage from "../../Domains/Service/Pages/ConnexionPage";
import MonParcPage from "../../Domains/Service/Pages/MonParcPage";
import LienDetailPage from "../../Domains/Service/Pages/LienDetailPage";
import VpnPage from "../../Domains/Service/Pages/VpnPage";
import VpnDetailPage from "../../Domains/Service/Pages/VpnDetailPage";
import DomainePage from "../../Domains/Service/Pages/DomainePage";
// import HebergementWebPage from "../../Domains/Service/Pages/HebergementWebPage";
import BaiesPage from '../../Domains/Service/Pages/BaiesPage';
import BaieDetailsPage from "../../Domains/Service/Pages/BaieDetailsPage";
import CableDetailsPage from "../../Domains/Service/Pages/CableDetailsPage";
import TelephoniePage from '../../Domains/Service/Pages/TelephoniePage';
import TelephonyConfigPage from '../../Domains/Service/Pages/TelephonyConfigPage';
import SuiviConsommationPage from '../../Domains/Service/Pages/SuiviConsommationPage';
import WebHebergementRedirectPage from '../../Domains/Service/Pages/WebHebergementRedirectPage';
import MessageriePage from '../../Domains/Service/Pages/MessageriePage';
import ComingSoon from '../common/components/ComingSoon';
import ConsommationLTE from '../../Domains/Service/Components/Acces/ConsommationLTE';
import DetailsDomaine from '../../Domains/Service/Components/Hebergement/DetailsDomaine';
import DomaineDetailPage from "../../Domains/Service/Pages/DomaineDetailPage";
import DomaineNsPage from "../../Domains/Service/Pages/DomaineNsPage";
import DomaineZoneDnsPage from "../../Domains/Service/Pages/DomaineZoneDnsPage";
import Database from '../../Domains/Service/Components/Hebergement/Database';
import OutilsTest from '../../Domains/Service/Components/Connexion/OutilsTest';
import TechnicalInformation from '../pages/configuration-list/configuration/cis/TechnicalInfo';
import DomaineEmailAccounts from '../../Domains/Service/Pages/Email-accounts/DomainEmailAccounts';
import DomainMailingLists from '../../Domains/Service/Pages/Email-accounts/DomainMailingLists';
import DomainMailingListMembers from '../../Domains/Service/Pages/Email-accounts/DomainMailingListMembers';
import DetailsTelephonie from '../../Domains/Service/Components/Telephonie/DetailsTelephonie';
import DetailsAppels from '../../Domains/Service/Components/Telephonie/DetailsAppels'
import LegacyTelephonyRedirect from '../../Domains/Service/Components/Telephonie/LegacyTelephonyRedirect';
import Subscriptions from '../pages/my-account/Subscriptions';
import SubscriptionDetail from '../pages/my-account/SubscriptionDetail';
import ContactsPage from '../../Domains/Account/Pages/ContactsPage';
import BillPage from '../pages/administrative/BillPage';
import LogManager from "../pages/user-manager/LogManager";
import DivopsPage from '../../Domains/Divops/Pages/DivopsPage';
import DivopsHistoryPage from '../../Domains/Divops/Pages/DivopsHistoryPage';
import ApsRequestPage from '../../Domains/Divops/Pages/ApsRequestPage';
import ApsHistoryPage from '../../Domains/Divops/Pages/ApsHistoryPage';
import DivopsMassEligibilitePage from '../../Domains/Divops/Pages/DivopsMassEligibilitePage';
import ConfigMonitoring from '../pages/configuration-list/configuration/cis/ConfigMonitoring';
import RouterConfigurationPage from '../../Domains/Router/Pages/RouterConfigurationPage';
import DocumentDownloadPage from '../../Domains/Document/Pages/DocumentDownloadPage';

export const routesConfig = [
  {
    path: 'dashboard',
    element: <DashboardV2 />,
    meta: {
      showBreadcrumb: false,
    },
  },
  {
    path: 'admin',
    element: (
      <SecuredRoute requiredPermissions={['ecAdmin']}>
        <AdminDashboard />
      </SecuredRoute>
    ),
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Admin'}],
    },
  },
  {
    path: 'support-list',
    element: (
      <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
        <SupportListPage />
      </SecuredRoute>
    ),
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Assistance & support'}],
    },
  },
  {
    path: 'reclamations',
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes demandes'}],
    },
    children: [
      {
        path: '',
        element: (
          <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
            <TicketPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes demandes'}],
        },
      },
      {
        path: ':ticketId',
        element: (
          <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
            <TicketDetailIndex activeKey={'demande-admin'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mes demandes', link: 'reclamations'},
            {name: 'Détail Demande'},
          ],
        },
      },
    ],
  },
  {
    path: 'support',
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Assistance & support'}],
    },
    children: [
      {
        path: '',
        element: (
          <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
            <TicketPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Assistance & support'}],
        },
      },
      {
        path: ':ticketId',
        element: (
          <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
            <TicketDetailIndex activeKey={'demande-admin'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Assistance & support', link: 'support'},
            {name: 'Détail Demande'},
          ],
        },
      },
    ],
  },
  {
    path: 'administrative',
    meta: {},
    children: [
      {
        path: 'demande-admin',
        element: (
          <SecuredRoute requiredPermissions={['voirAdministratifFacture']}>
            <TicketPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes demandes'}],
        },
      },
      {
        path: 'demande-technique',
        element: (
          <SecuredRoute requiredPermissions={['voirTicketsEnCours']}>
            <TicketPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes demandes'}],
        },
      },
      {
        path: 'bill',
        element: (
          <SecuredRoute requiredPermissions={['voirAdministratifFacture']}>
            <TicketPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mes demandes', link: 'reclamations'},
            {name: 'Factures'},
          ],
        },
      },
      {
        index: true,
        element: (
          <NavigateToFirstAllowedRoute
            redirects={[
              {permission: 'voirAdministratifFacture', path: 'demande-admin'},
              {permission: 'voirTicketTechnique', path: 'demande-technique'},
            ]}
          />
        ),
      },
    ],
  },
  {
    path: 'documents',
    meta: {},
    children: [
      {
        path: 'commercial',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsContractuels']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Contractuel'}],
        },
      },
      {
        path: 'technique',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsTechniques']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Technique'}],
        },
      },
      {
        path: 'administratif',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsAdministratifs']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Documents', link: 'documents'},
            {name: 'Administratif'},
          ],
        },
      },
      {
        path: 'fibre',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsFibre']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Documents', link: 'documents'},
            {name: 'Fibre'},
          ],
        },
      },
      {
        path: 'rapport-roc',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsRoc']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Documents', link: 'documents'},
            {name: 'Rapport ROC'},
          ],
        },
      },
      {
        path: 'service-client',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsRelationClient']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Relation client'}],
        },
      },
      {
        path: 'bills',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsRelationClient']}>
            <Documents />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Factures'}],
        },
      },
      {
        path: 'download/:fileId',
        element: (
          <SecuredRoute requiredPermissions={['voirDocuments']}>
            <DocumentDownloadPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Téléchargement'}],
        },
      },
      {
        index: true,
        element: <Navigate to="commercial" replace />,
      },
    ],
  },
  {
    path: 'bills',
    element: (
      <SecuredRoute requiredPermissions={['voirDocuments', 'voirDocumentsRelationClient']}>
        <BillPage />
      </SecuredRoute>
    ),
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes factures'}],
    },
  },
  {
    path: 'mon-parc',
    element: (
      <SecuredRoute requiredPermissions={['voirEtatParc']}>
        <MonParcPage />
      </SecuredRoute>
    ),
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mon parc'}],
    },
  },
  {
    path: 'orders',
    meta: {},
    children: [
      {
        path: 'in-progress',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'in-progress'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: 'delivered-orders',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'delivered-orders'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: 'canceled-orders',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'canceled-orders'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: 'closed-orders',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'closed-orders'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: 'in-production-orders',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'in-production-orders'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: 'pending-closing-orders',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
            <OrderTracking activeKey={'pending-closing-orders'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Mes commandes'}],
        },
      },
      {
        path: ':id',
        element: (
          <SecuredRoute requiredPermissions={['voirSuiviCommande']}>
            <OrderDetails />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mes commandes', link: 'orders'},
            {name: 'Détails Commande'},
          ],
        },
      },
      {
        index: true,
        element: <Navigate to="in-progress" replace />,
      },
    ],
  },
  {
    path: 'services',
    meta: {},
    children: [
      {
        path: 'connexion',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ServiceList activeKey={'connexion'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Connexion'}],
        },
      },
      {
        path: 'connexion/liens',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ConnexionPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Liens'}],
        },
      },
      {
        path: 'connexion/liens/:serviceId',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <LienDetailPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Liens', link: 'services/connexion/liens' },
            { name: 'Détail' }
          ]
        },
      },
      {
        path: 'connexion/vpn',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <VpnPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'VPN'}],
        },
      },
      {
        path: 'connexion/vpn/:serviceId',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <VpnDetailPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'VPN', link: 'services/connexion/vpn' },
            { name: 'Détail' }
          ]
        },
      },
      {
        path: 'telephonie',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ServiceList activeKey={'telephonie'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Téléphonie'}],
        },
      },
      {
        path: 'monitoring',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <ConfigMonitoring />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Configuration Monitoring'}],
        },
      },
      {
        path: 'telephonie/suivi-consommation',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <SuiviConsommationPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Téléphonie', link: 'services/telephonie/liste'},
            {name: 'Suivi de consommation'},
          ],
        },
      },
      {
        path: 'telephonie/configuration',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <TelephonyConfigPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Téléphonie', link: 'services/telephonie/liste'},
            {name: 'Configuration'},
          ],
        },
      },
      {
        path: 'telephonie/liste',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <TelephoniePage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Téléphonie'}],
        },
      },
      {
        path: 'telephonie/:serviceId',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DetailsTelephonie />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Téléphonie', link: 'services/telephonie'},
            {name: 'Détails Téléphonie'},
          ],
        },
      },
      {
        path: 'telephonie/:serviceId/appels',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DetailsAppels />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Téléphonie', link: 'services/telephonie'},
            {name: 'Détails Appels'},
          ],
        },
      },
      // Anciennes URL (?cisId=…) conservées pour les favoris et liens externes
      {
        path: 'telephonie/details-telephonie',
        element: <LegacyTelephonyRedirect />,
      },
      {
        path: 'telephonie/details-appels',
        element: <LegacyTelephonyRedirect suffix="/appels" />,
      },
      {
        path: 'hebergement',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ServiceList activeKey={'hebergement'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Hébergement'}],
        },
      },
      {
        path: 'ftp',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <WebFtpConsommation />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Hébergement', link: 'services/hebergement'},
            {name: 'Compte FTP'},
          ],
        },
      },
      {
        path: 'database',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <Database />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Hébergement', link: 'services/hebergement'},
            {name: 'bases de données'},
          ],
        },
      },
      {
        path: 'consommationLTE',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ConsommationLTE />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Connexion', link: 'services/connexion'},
            {name: 'Consommation 4G'},
          ],
        },
      },
      {
        path: 'domaine/liste',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomainePage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Noms de domaine et DNS'}],
        },
      },
      {
        path: 'domaine/infos',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DetailsDomaine />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Noms de domaine et DNS', link: 'services/domaine/liste'},
            {name: 'Informations du domaine'},
          ],
        },
      },
      {
        path: 'domaine/detail',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomaineDetailPage/>
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Noms de domaine et DNS', link: 'services/domaine/liste' },
            { name: 'Détail du domaine' },
          ],
        },
      },
      {
        path: 'domaine/ns',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomaineNsPage/>
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Noms de domaine et DNS', link: 'services/domaine/liste' },
            { name: 'Détail du domaine', link: 'services/domaine/detail' },
            { name: 'Modifier les NS' },
          ],
        },
      },
      {
        path: 'domain/emails',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomaineEmailAccounts />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Hébergement', link: 'services/hebergement'},
            {name: 'Gestion des comptes email'},
          ],
        },
      },
      {
        path: 'domain/:domainName/mailing-lists',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomainMailingLists />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Hébergement', link: 'services/hebergement'},
            {name: 'Gestion des comptes email', link: 'services/domain/emails'},
            {name: 'Gestion des listes'},
          ],
        },
      },
      {
        path: 'domain/emails/:domainName/lists/:listId/members',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomainMailingListMembers />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Hébergement', link: 'services/hebergement'},
            {name: 'Gestion des comptes email', link: 'services/domain/emails'},
            {name: 'Gestion des listes', link: 'services/domain/:domainName/mailing-lists'},
            {name: 'Membres de la liste'},
          ],
        },
      },

      {
        path: 'domaine/zone-dns',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <DomaineZoneDnsPage/>
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Noms de domaine et DNS', link: 'services/domaine/liste' },
            { name: 'Détail du domaine', link: 'services/domaine/detail' },
            { name: 'Zone DNS' },
          ],
        },
      },
      {
        path: 'dns-zones',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_DNS" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Zones DNS'}]},
      },
      {
        path: 'certificats',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_DNS" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Certificats'}]},
      },
      {
        path: 'messagerie',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <MessageriePage />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Messagerie'}]},
      },
      {
        path: 'microsoft-mail',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_EMAILS" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Microsoft Mail'}]},
      },
      {
        path: 'm365',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_EMAILS" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Microsoft 365'}]},
      },
      {
        path: 'web-hebergement',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <WebHebergementRedirectPage />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Hébergement'}]},
      },
      {
        path: 'wordpress',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_WEB" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'WordPress'}]},
      },
      {
        path: 'baies',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <BaiesPage />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Baies'}]},
      },
      {
        path: 'baies/details',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <BaieDetailsPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Baies', link: 'services/baies' },
            { name: 'Détail' },
          ],
        },
      },
      {
        path: 'baies/details/cable',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <CableDetailsPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            { name: 'Accueil', link: 'dashboard' },
            { name: 'Baies', link: 'services/baies' },
            { name: 'Détail' },
          ],
        },
      },
      {
        path: 'vms',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_INFRA" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'VMs'}]},
      },
      {
        path: 'vps',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_INFRA" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'VPS'}]},
      },
      {
        path: 'dedie',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <ComingSoon title="MENU.CLOUD.GROUP_INFRA" />
          </SecuredRoute>
        ),
        meta: {breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Dédié'}]},
      },
      {
        index: true,
        element: <Navigate to="connexion" replace />,
      },
    ],
  },
  {
    path: 'configuration',
    meta: {},
    children: [
      {
        path: 'routeurs-vpn',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <ConfigurationList />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Routeurs et VPN'}],
        },
      },
      {
        path: 'routeurs-vpn/technical-information',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <TechnicalInformation />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Routeurs et VPN', link: 'configuration/routeurs-vpn'},
            {name: 'Informations techniques'},
          ],
        },
      },
      {
        path: 'routeurs-vpn/outilstest',
        element: (
          <SecuredRoute requiredPermissions={['voirEtatParc']}>
            <OutilsTest />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Routeurs et VPN', link: 'configuration/routeurs-vpn'},
            {name: 'OutilsTest'},
          ],
        },
      },
      {
        path: 'telephonie',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <ConfigurationList />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Téléphonie'}],
        },
      },
      {
        path: 'administration',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <ConfigurationList />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Administration'}],
        },
      },
      {
        path: 'routeurs/:routerId',
        element: (
          <SecuredRoute requiredPermissions={['voirConfiguration']}>
            <RouterConfigurationPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Configuration'},
            {name: 'Routeur'},
          ],
        },
      },

      {
        index: true,
        element: <Navigate to="routeurs-vpn" replace />,
      },
    ],
  },
  {
    path: 'marketplace',
    meta: {},
    children: [
      {
        path: 'acces',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <Marketplace activeKey={'acces'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Marketplace'},
            {name: 'Accès internet'},
          ],
        },
      },
      {
        path: 'telephonie',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <Marketplace activeKey={'telephonie'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Marketplace'},
            {name: 'Téléphonie'},
          ],
        },
      },
      {
        path: 'hebergement',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <Marketplace activeKey={'hebergement'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Marketplace'},
            {name: 'Hébergement'},
          ],
        },
      },
      {
        path: 'hebergement/:categoryId',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <Marketplace activeKey={'hebergement'} />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Marketplace'},
            {name: 'Hébergement'},
          ],
        },
      },
      {
        index: true,
        element: <Navigate to="acces" replace />,
      },
    ],
  },

  {
    path: 'contact',
    element: (
      <SecuredRoute requiredPermissions={['voirSuiviCommande', 'voirCommandesEnCoursResilie']}>
        <Contact />
      </SecuredRoute>
    ),
    meta: {
      breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Contact'}],
    },
  },
  {
    path: 'settings',
    meta: {},
    children: [
      {
        path: 'authorization',
        element: <BuManagerV2 />,
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Gestion des Autorisations'}],
        },
      },
    ],
  },
  {
    path: 'History',
    meta: {},
    children: [
      {
        path: 'log',
        element: <LogManager />,
        meta: {
          breadcrumb: [{name: 'Accueil', link: 'dashboard'}, {name: 'Historique des activités'}],
        },
      },
    ],
  },
  {
    path: 'my-account',
    meta: {},
    children: [
      {
        path: 'contacts',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <ContactsPage />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mon compte', link: 'my-account'},
            {name: 'Mes interlocuteurs'},
          ],
        },
      },
      {
        path: 'subscriptions',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <Subscriptions />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mon compte', link: 'my-account'},
            {name: 'Mes abonnements'},
          ],
        },
      },
      {
        path: 'subscriptions/:id',
        element: (
          <SecuredRoute requiredPermissions={[]}>
            <SubscriptionDetail />
          </SecuredRoute>
        ),
        meta: {
          breadcrumb: [
            {name: 'Accueil', link: 'dashboard'},
            {name: 'Mon compte', link: 'my-account'},
            {name: 'Mes abonnements', link: 'my-account/subscriptions'},
            {name: "Détail de l'abonnement"},
          ],
        },
      },
      {
        index: true,
        element: <Navigate to="subscriptions" replace />,
      },
    ],
  },
  {
    path: 'divops',
    element: <DivopsPage />,
    meta: {
      breadcrumb: [
        {name: 'Accueil', link: 'dashboard'},
        {name: 'DivOps'},
      ],
    },
  },
  {
    path: 'divops/historique',
    element: <DivopsHistoryPage />,
    meta: {
      breadcrumb: [
        {name: 'Accueil', link: 'dashboard'},
        {name: 'DivOps', link: 'divops'},
        {name: 'Historique des recherches'},
      ],
    },
  },
  {
    path: 'divops/aps',
    element: <ApsRequestPage />,
    meta: {
      breadcrumb: [
        {name: 'Accueil', link: 'dashboard'},
        {name: 'DivOps', link: 'divops'},
        {name: 'Demande APS'},
      ],
    },
  },
  {
    path: 'divops/aps/historique',
    element: <ApsHistoryPage />,
    meta: {
      breadcrumb: [
        {name: 'Accueil', link: 'dashboard'},
        {name: 'DivOps', link: 'divops'},
        {name: 'Demande APS', link: 'divops/aps'},
        {name: 'Historique des demandes'},
      ],
    },
  },
  {
    path: 'divops/eligibilite-masse',
    element: <DivopsMassEligibilitePage />,
    meta: {
      breadcrumb: [
        {name: 'Accueil', link: 'dashboard'},
        {name: 'DivOps', link: 'divops'},
        {name: 'Éligibilité en masse'},
      ],
    },
  },
  {
    path: '*',
    element: <Navigate to="/error/404" replace />,
    meta: {
      breadcrumb: 'Erreur 404',
    },
  },
];
